import React from "react";
import {Box, Column, Columns, Table, Title} from "@allxsmith/bestax-bulma";
import {formatDateTime} from "../../utils";



export default function PrintLog({rental}){



    return (
        <Box>
            <details>
                <summary><Title>Print Log</Title></summary>
            <Columns isMultiline>
                <Column>
                    <Table isFullwidth>
                        <thead>
                            <tr>
                                <th>Date/Time</th>
                                <th>User</th>
                            </tr>
                        </thead>
                        <tbody>
                        {rental.rental_print_log && rental.rental_print_log.map(log => (
                            <tr>
                                <td>{formatDateTime(new Date(log.timestamp))}</td>
                                <td>{log.user ? log.user.first_name + " " +log.user.last_name : ""}</td>
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                </Column>
            </Columns>
            </details>
        </Box>
    );

}